export const EDIT_UNSAVED_DIALOG_ACTIONS = (t) => [
  {
    key: 'cancel',
    text: t('general.cancel'),
    color: 'grey',
    hoverColor: 'grey',
    textBtn: true,
    outlined: true,
    light: true,
    width: '125',
    height: '44',
    borderRadius: '8px',
    event: 'cancel',
    class: 'cancel-btn',
  },
  {
    key: 'discard',
    text: t('general.discardDialogDiscardBtnText'),
    color: 'grey',
    hoverColor: 'grey',
    textBtn: true,
    outlined: true,
    light: true,
    width: '125',
    height: '44',
    borderRadius: '8px',
    event: 'discard',
    class: 'discard-btn',
  },
  {
    key: 'save',
    text: t('bookingEdit.submitBtn'),
    color: 'primary',
    width: '147',
    height: '44',
    borderRadius: '8px',
    event: 'save',
    class: 'save-btn',
  },
]
